import React from "react";
import { Instagram, Twitter } from "lucide-react";
import { AppStoreBadge, PlayStoreBadge } from "./StoreBadges";
import { ASSETS } from "./assets";

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative border-t border-neutral-900 pt-20 pb-6"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* CTA band */}
        <div className="border border-[#D4F34A]/30 bg-[#D4F34A]/[0.04] p-8 md:p-14 mb-20">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-3">
                Ready to play?
              </div>
              <h3
                data-testid="footer-cta-heading"
                className="font-display uppercase tracking-tight text-4xl md:text-6xl leading-[0.9]"
              >
                Take Rallie
                <br />
                to the court.
              </h3>
            </div>
            <div className="flex flex-wrap gap-3 md:justify-end">
              <AppStoreBadge testId="footer-app-store" />
              <PlayStoreBadge testId="footer-play-store" />
            </div>
          </div>
        </div>

        {/* Link grid */}
        <div
          data-testid="footer-links"
          className="grid grid-cols-2 md:grid-cols-4 gap-8 pb-14 border-b border-neutral-900"
        >
          <div>
            <div className="mb-4 -ml-1">
              <img
                src={ASSETS.logo}
                alt="Rallie — Padel Americano Tournaments"
                data-testid="footer-logo"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-neutral-500 max-w-[220px] leading-relaxed">
              Made for padel players, by padel players.
            </p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-widest text-neutral-500 mb-4">
              Product
            </div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li>
                <a
                  href="#features"
                  data-testid="footer-link-features"
                  className="hover:text-[#D4F34A]"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#how"
                  data-testid="footer-link-how"
                  className="hover:text-[#D4F34A]"
                >
                  How it works
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  data-testid="footer-link-pricing"
                  className="hover:text-[#D4F34A]"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  data-testid="footer-link-faq"
                  className="hover:text-[#D4F34A]"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-widest text-neutral-500 mb-4">
              Legal
            </div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li>
                <a
                  href="/privacy"
                  data-testid="footer-link-privacy"
                  className="hover:text-[#D4F34A]"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  data-testid="footer-link-terms"
                  className="hover:text-[#D4F34A]"
                >
                  Terms of Use
                </a>
              </li>
              <li>
                <a
                  href="/support"
                  data-testid="footer-link-support"
                  className="hover:text-[#D4F34A]"
                >
                  Support
                </a>
              </li>
              <li>
                <a
                  href="/delete-account"
                  data-testid="footer-link-delete-account"
                  className="hover:text-[#D4F34A]"
                >
                  Delete Account
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@rallie.app"
                  data-testid="footer-link-contact"
                  className="hover:text-[#D4F34A]"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-widest text-neutral-500 mb-4">
              Follow
            </div>
            <div className="flex items-center gap-3">
              <a
                href="#"
                aria-label="Instagram"
                data-testid="footer-social-instagram"
                className="w-10 h-10 rounded-full border border-neutral-800 hover:border-[#D4F34A] hover:text-[#D4F34A] flex items-center justify-center transition"
              >
                <Instagram size={16} />
              </a>
              <a
                href="#"
                aria-label="Twitter/X"
                data-testid="footer-social-twitter"
                className="w-10 h-10 rounded-full border border-neutral-800 hover:border-[#D4F34A] hover:text-[#D4F34A] flex items-center justify-center transition"
              >
                <Twitter size={16} />
              </a>
            </div>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="py-16 flex items-center justify-center">
          <div
            data-testid="footer-wordmark"
            className="font-display uppercase text-[22vw] md:text-[18vw] leading-none tracking-tighter text-white/[0.06] select-none"
          >
            Rallie
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between text-[11px] uppercase tracking-widest text-neutral-600 gap-2">
          <div>© {new Date().getFullYear()} Rallie. All rights reserved.</div>
          <div>Built for the court · iOS · Android</div>
        </div>
      </div>
    </footer>
  );
}
